import {
  DelimiterStyled,
  NotificationsContent,
  NotificationsHeader,
} from 'components/Layout/Header/NotificationsFeature/components';
import { useInfiniteScroll } from 'hooks';
import { Icon } from 'libs/ui/Icon';

import { useNotifications } from './hooks';
import { NotificationPressedStyled, PopoverStyled } from './styles';

export const NotificationsFeature = () => {
  const {
    isNewNotifications,
    listData,
    loading,
    hasMore,
    openPopover,
    onLoadMore,
    onClosePopover,
    onOpenPopover,
    anchorEl,
  } = useNotifications();

  const { lastElementRef } = useInfiniteScroll({
    loading,
    hasMore,
    onLoadMore,
  });

  return (
    <>
      <NotificationPressedStyled onClick={onOpenPopover}>
        {isNewNotifications ? (
          <Icon.BellMark size={25} />
        ) : (
          <Icon.Bell size={24} />
        )}
      </NotificationPressedStyled>
      <PopoverStyled
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={openPopover}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={onClosePopover}
      >
        <NotificationsHeader onClosePopover={onClosePopover} />
        <DelimiterStyled />
        <NotificationsContent
          lastElementRef={lastElementRef}
          listData={listData}
          loading={loading}
          onClosePopover={onClosePopover}
        />
      </PopoverStyled>
    </>
  );
};
